import { ContentEntity } from "api/src/content/entity/content.entity";
import { useQuery, useQueryClient } from "react-query";

import { api } from "../util/api";

export function useReviewContent(contentId?: string) {
  const queryClient = useQueryClient();

  return useQuery<ContentEntity | undefined>(
    ["content", "review-single", contentId],
    async () => {
      const response = await api.get<ContentEntity>(
        `content/review/${contentId}`,
        {}
      );

      if (response.status === 200) {
        return response.data;
      }

      return undefined;
    },
    {
      keepPreviousData: true,
      enabled: !!contentId,
      onSuccess: () => {
        queryClient.invalidateQueries(["content", "review"]);
      },
    }
  );
}
